import { useEffect, useMemo, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { motion } from "framer-motion";
import api from "@/lib/api";
import ProductCard from "@/components/ProductCard";

const CITIES = [
  { key: "vegas", label: "Vegas", code: "702", dog: "King", tag: "Neon strip drop",
    img: "https://images.unsplash.com/photo-1601056645460-05fd9ad8f4e0?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200" },
  { key: "miami", label: "Miami", code: "305", dog: "Smiley", tag: "Aqua hypercolor",
    img: "https://images.unsplash.com/photo-1533106497176-45ae19e68ba2?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200" },
  { key: "nyc", label: "NYC / PR", code: "917", dog: "Beats", tag: "After dark",
    img: "https://images.unsplash.com/photo-1541702467897-41915a07d3a7?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200" },
];

export default function Collabs() {
  const [params, setParams] = useSearchParams();
  const active = params.get("city") || "vegas";
  const [all, setAll] = useState([]);

  useEffect(() => { api.get("/products").then(({ data }) => setAll(data)).catch(() => {}); }, []);

  const cityProducts = useMemo(() => all.filter((p) => p.city === active), [all, active]);
  const current = CITIES.find((c) => c.key === active) || CITIES[0];

  return (
    <div data-testid="collabs-page">
      <section className="relative overflow-hidden grain border-b border-primary/20">
        <img src={current.img} alt={current.label} className="absolute inset-0 h-full w-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-r from-background via-background/80 to-background/40" />
        <div className="relative max-w-7xl mx-auto px-5 sm:px-8 py-24">
          <p className="overline text-primary mb-4">City Collabs · {current.code}</p>
          <h1 className="text-5xl sm:text-6xl font-modern font-semibold tracking-tighter leading-[0.92]">{current.label} <span className="aqua-text">{current.code}</span></h1>
          <p className="mt-5 text-muted-foreground max-w-xl">{current.tag} — repped by {current.dog}. Limited hoodies, tees &amp; dog gear from the {current.label} roots.</p>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-5 sm:px-8 py-12">
        <div className="flex gap-2 mb-10 overflow-x-auto no-scrollbar">
          {CITIES.map((c) => (
            <button key={c.key} onClick={() => setParams({ city: c.key })}
              className={`overline whitespace-nowrap px-5 py-2.5 rounded-full border transition-colors ${active === c.key ? "bg-primary text-primary-foreground border-primary" : "border-white/15 text-muted-foreground hover:text-white"}`}
              data-testid={`collab-tab-${c.key}`}>
              {c.label}
            </button>
          ))}
        </div>

        {cityProducts.length === 0 ? (
          <p className="text-muted-foreground py-16 text-center" data-testid="collab-empty">This drop is loading — check back soon.</p>
        ) : (
          <motion.div key={active} initial={{ opacity: 0 }} animate={{ opacity: 1 }} className="grid grid-cols-2 lg:grid-cols-4 gap-5" data-testid="collab-grid">
            {cityProducts.map((p, i) => <ProductCard key={p.id} product={p} index={i} />)}
          </motion.div>
        )}
      </section>
    </div>
  );
}
